import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import {
  formatDateString,
  getOrderDate,
} from "../../utils/outbound-labels-utils";

const catalogEntry = fgColumnEntries["order-date"];

export const OrderDateColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => (
    <RedoTableTextCell
      subtext={getOrderDate(row)
        ?.toLocaleTimeString(undefined, {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        })
        .toLowerCase()}
      text={formatDateString(getOrderDate(row)?.toISOString() ?? "")}
    />
  ),
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
};
